module.exports = __webpack_public_path__ + "img/homepro1.68d223d7.jpeg";